import TableCellBranch from "ds/components/Table/Row/CellBranch";

import StackPullRequestsTableGroupCell from "../../GroupCell";
import { StackPullRequestsTablePullRequestCellProps } from "../types";

const StackPullRequestsTablePullRequestBranchCell = ({
  item: pullRequest,
  ...cellProps
}: StackPullRequestsTablePullRequestCellProps) => {
  return (
    <StackPullRequestsTableGroupCell item={pullRequest} {...cellProps}>
      <TableCellBranch href={pullRequest.headBranchURL}>{pullRequest.headBranch}</TableCellBranch>
    </StackPullRequestsTableGroupCell>
  );
};

export default StackPullRequestsTablePullRequestBranchCell;
